export default {
    badge: "merkki",
    close: "kiinnittyä",
    dataIterator: {
        noResultsText: "Ei löydy sopivia tallenteita",
        loadingText: "Tallenne latautuu..."
    },
    dataTable: {
        itemsPerPageText: "Rivien määrä sivulla:",
        ariaLabel: {
            sortDescending: "Lajiteltu laskevaan järjestykseen.",
            sortAscending: " Lajiteltu nousevaan järjestykseen.",
            sortNone: "Ei lajiteltu.",
            activateNone: "Aktivoikaa lajittelun pois ottamiseen.",
            activateDescending: "Aktivoikaa laskevaan järjestykseen lajittelua varten.",
            activateAscending: " Aktivoikaa laskevaan järjestykseen lajittelua varten.",
        },
        sortBy: "Lajittele",
    },
    dataFooter: {
        itemsPerPageText: "Tallenteita sivulla:",
        itemsPerPageAll: "Kaikki tallenteet",
        nextPage: "Seuraava sivu",
        prevPage: "Edellinen sivu",
        firstPage: "Ensimmäinen sivu",
        lastPage: "Viimeinen sivu",
        pageText: "{0}-{1} {2}:sta"
    },
    datePicker: {
        itemsSelected: "{0} valittu",
        nextMonthAriaLabel: "Seuraava kuukausi",
        nextYearAriaLabel: "Seuraava vuosi",
        prevMonthAriaLabel: "Viime kuukausi",
        prevYearAriaLabel: "Viime vuosi"
    },
    noDataText: "Tieto puuttuu",
    carousel: {
        prev: "Edellinen kuultokuva",
        next: "Seuraava kuultokuva",
        ariaLabel: {
            delimiter: "Kuultokuva {0} {1}:sta"
        }
    },
    calendar: {
        moreEvents: "Enemmän {0}"
    },
    fileInput: {
        counter: "Tiedostoja: {0}",
        counterSize: "Tiedostoja: {0} (yhteensä {1})"
    },
    timePicker: {
        am: "AM",
        pm: "PM"
    },
    pagination: {
        ariaLabel: {
            wrapper: "Suunnistus sivuilla",
            next: "Seuraava sivu",
            previous: "Edellinen sivu",
            page: "Siirto seuraavalle sivulle {0}",
            currentPage: "Nykyinen sivu, Sivu {0}"
        }
    },
    rating: {
        ariaLabel: {
            icon: "Rankkaus {0} {1}:sta"
        }
    },

    start: "Alku",
    deadline: "Päättymisaika",
    sure: "Olette varma",
    sureArchive: "Vahvistakaa arkistointia",
    sureOutArchive: "Vahvistakaa desarkistointia",
    yes: "kyllä",
    value: "Tarkoitus",
    addNew: "Lisää uutinen",
    uploadNewsImage: "Ladata kansia (jpg, png)",
    publish: "Julkaista",
    title: "Otsikko",
    addEvent: "Lisätä tapahtuma",
    today: "Tänään",
    month: "Kuukausi",
    day: "Päivä",
    addingEvent: "Tapahtuman lisääminen",
    editingEvent: "Tapahtuman muotoilu",
    deletingEvent: "Tapahtuman poisto",
    time: "Aika",
    endDate: "Lopun päivämäärä",
    allDay: "Koko päivä",
    period: "Ajanjakso",
    confirmDeleteEvent: "Oletteko tosissaan poistamassa tätä tapahtumaa? Tämän teon peruminen on mahdoton",
    forWhomRule: "Valitkaa kenelle on tapahtuma",
    forWhom: "Ketä varten",
    forSelf: "Itselle",
    forGroup: "Ryhmälle",
    forAll: "Kaikille",
    forUser: "Käyttäjälle",
    description: "Kuvaus",
    confirm: "Vahvista",
    aboutObject: "Objektista",
    worksEnd: "Työn päättymisaika",
    worksEndLate: "Päättymispäivä viiveellä",

    worksStart: "Työn alkamisaika",
    objectName: "Objektin nimi",
    square: "Neliön kuvamateriaalia",
    accidentInsurance: "Tapaturman vakuutus ",
    healthInsurance: "Terveyden vakuutus",
    habitation: "asunto",
    number: "Numero",
    name2: "Nimi",
    shortName: "Lempinimi",
    position: "Työpaikka",
    name: "Nimi",
    surname: "Sukunimi",
    no: "ei",
    have: "on",
    phone: "Puhelinnumero",
    email: "Sähköposti",
    ogrn: "Y-tunnus",
    address: "Osoite",
    staff: "Henkilökunta",
    documents: "Dokumentit",
    planning: "Suunniteltu",
    inProgress: "Prosessissa",
    finished: "Lopetettu",
    back: "Takaisin",
    cancel: "Peruuttaa",
    forward: "Tuleva",
    documentName: "Dokumentin nimi",
    documentType: "Dokumentin laji",
    dateDownload: "Latauksen päivämäärä",
    objectNumber: "Objektin numero",
    objectAddress: "Objektin osoite",
    client: "Asiakas",
    clientPhone: "Asiakkaan puhelinnumero",
    clientEmail: " Asiakkaan sähköpostiosoite",
    employesOnObject: "Työntekijät",
    workList: "Työtehtävät",
    comments: "Kommentteja",
    comment: "Kommentti",
    news: "Uutiset",
    readAlso: "Lukea myös",
    save: "Tallentaa",
    addCard: "Lisätä korttia",
    addWork: "Lisätä työtä",
    addEmployee: "Lisätä työntekijää",
    addObject: "Lisätä objektia",
    editObject: "Korjata objektia",
    addContact: "Lisätä kontaktia",
    editContact: "Korjata kontaktia",
    addGroup: "Lisätä ryhmää",
    editGroup: "Korjata ryhmää",
    addTimeReport: "Uusi raportti",
    editTimeReport: "Korjata raporttia",
    addClient: "Lisätä asiakasta",
    addDocument: "Lisätä dokumenttia",
    add: "Lisätä",
    changePhoto: "Vaihda valokuvaa",
    changeSignature: "Vaihda signature",
    changeDocument: "Vaihda dokumenttia",
    bankAccount: "Tilinumero",
    systemRole: "Rooli systeemissä",
    aboutEmployee: "Työntekijästä",
    cards: "Kortit ja kulkuluvat",
    skills: "Kykyjä",
    roof: "Katon asentaminen",
    floor: "Lattian asettaminen",
    personalInfo: "Henkilötiedot",
    citizenship: "Kansalaisuus",
    birthday: "Syntymäpäivämäärä",
    addressOwn: "Oman maan osoite",
    addressFin: "Osoite Suomessa",
    otherPhone: "Toinen puhelinnumero",
    additional: "Lisättävää",
    driverLicense: "Ajokortti",
    driverLicenseCat: "Ajokortin Tyyppi",
    ownCar: "Henkilöauto",
    ownTools: "Omat Työkalut",
    haveOwnCar: "On olemassa oma auto",
    haveOwnTools: "On olemassa omat työkalut",
    languages: "Kielet",
    uniform: "Työasu",
    editPersonal: "Henkilökohtaisen tiedon korjaaminen",
    editAdditional: "Lisätiedon korjaaminen",
    fromFinland: "Olen Suomesta",
    fromAnotherCountry: "Olen ulkomaalta",
    socialCodeFin: "Suomen henkilötunnus",
    taxNumber: "Veronumero",
    street: "Katu",
    house: "Talo",
    flat: "Asunto",
    entrance: "Portti",
    index: "Postinumero",
    city: "Kaupunki",
    country: "Maa",
    sizeUniform: "Työkenkään koko",
    size: "Koko",
    shirt: "Paita",
    pants: "Housut",
    jacket: "Takki",
    boots: "Saappaat",
    gloves: "Hanskat",
    cardNumber: "Dokumentin numero",
    dueDate: "Voimassa asti",
    uploadImg: "Ladata kuvaa (jpg, png)",
    changeImg: "Vaihtaa kuvaa (jpg, png)",
    deleteCard: "Poistaa korttia",
    paintingWorks: "Maalaustyöt",
    outdoor: "Ulkopuolella",
    indoor: "Sisällä",
    plastering: "Rappaaminen",
    manual: "Manuaali",
    hardware: "Laitteisto",
    facade_plasteir: "Julkisivun rappaaminen",
    chain: "Metalliverkon kanssa",
    plasterboard: "Muoviverkon kanssa",
    alignment: "Tasaus",
    carpentry: "Puusepän työt",
    simple: "Tavalliset",
    formwork: "Puuverkon kanssa",
    suspendedCeilings: "Ripustettu sisäkatto",
    giprok: "Gyproc",
    panels: "Paneelit",
    partitionWalls: "Jakoseinä",
    tileWaterproofing: "Kaakeli ja kosteussuojaus",
    Floor: "Lattian asentaminen",
    parquet: "Parketti",
    laminate: "Laminaatti",
    masonry: "Muurarin työt",
    concrete_works: "Betoonityöt",
    reinforcement: "Vahvike",
    tiles: "Kattotiili",
    metal: "Metalli",
    bitumen: "Bitumityöt",
    bitumen_roof: "Bitumi katto",
    bitumen_plinth: "Jalusta",
    welding: "Hitsaus",
    diamondCuttingDrilling: "Timanttisahaukset ja poraukset",
    fillForm: "Täyttäkää kaikki pakolliset lomakkeet",
    addDocumentRule: "Liitä dokumenttia",
    required: "Pakollinen",
    enterText: "Kirjoittakaa viestinne",
    enterWorkText: "Kirjoittakaa työtyypin nimi",
    lettersOnly: "Vain kirjaimet",
    incorrectEmail: "Virheellinen sähköpostiosoite",
    companyName: "Yrityksen nimi",
    activityType: "Toiminnan laji",
    regNumber: "Y-tunnus",
    website: "Verkkosivu",
    logo: "Logo",
    editClient: "Korjata asiakkaan tiedot",
    edit: "Korjata",
    delete: "Poistaa",
    surnameName: "Sukunimi, nimi",
    speciality: "Ammatti",
    company: "Yrityksen nimi",
    mainInfo: "Tärkeimmät tiedot",
    downloadDocument: "Ladata dokumenttia (pdf, doc, docx, jpg)",
    downloadPhoto: "Ladata kuvaa (jpg, png)",
    date: "Päivämäärä",
    workType: "Tehdyt työt",
    selectObjectLabel: "Objektti",
    selectWorker: "Valitkaa työntekijää",
    selectClient: "Valitkaa asiakasta",
    selectContact: "Valitkaa kontaktitietoa",
    wages: {
        label: "Maksutapa",
        piecework: "Keikkatyö",
        hourly: "Tuntityö",
        fixed: "Kokoaikatyö",
        sum: "Maksu",
        rate: "Korko",
        quantity: "Määrä",
        measurement: "Numeroiden määrä",
        hours: "Tuntimäärä",
        time: "Aika (h)"
    },
    measurements: {
        kg: "kg",
        g: "g",
        m: "m",
        m2: "m2",
        m3: "m3",
        pc: "kpl",
        rll: "rll"
    },
    typeBody: "Rungon tyyppi",
    vin: "Auton valmistenumero VIN",
    regData: "Rekisteriote",
    carView: "Ulkonäkö",
    carTechnic: "Teknillisiä tuntomerkkejä",
    carDocuments: "Autodokumentit",
    regDate: "Rekisteröintipäivä",
    odometer: "Matkamittari (km)",
    engine: "Moottori",
    fuel: "Öljy tyyppi",
    typeDrive: "Vedon tyyppi",
    transmission: "Vaihdelaatikko",
    color: "Väri",
    characteristics: "Ominaisuudet",
    sorts: {
        sortBy: "Määritä",
        search: "Haku",
        searchMan: "Haku nimellä, puhelinnumerolla tai sähköpostiosoitteella",
        searchWorker: "Haku Työtekijän nimellä",
        searchObject: "Haku nimellä, puhelinnumerolla tai osoitteella",
        searchCar: "Haku nimellä, rekisteriotteella tai autovalmistenumerolla (vin)",
        searchName: "Hae nimellä, numerolla",
        searchWaybills: "Haku osoitteella",
        searchContracts: "Haku kontaktitiedolla",
        searchDocuments: "Haku dokumentin nimellä",
        byObjects: "Objektin järjestyksessä ",
        byWorkType: "Työlajin järjestyksessä ",
        bySum: "summan koon järjestyksessä",
        byTotalSum: "kokonaismäärän järjestyksessä",
        byDate: "päivämäärän järjestyksessä",
        byCreateDate: "liittymispäivämäärän järjestyksessä",
        byStartDate: "alkamispäivä järjestyksessä",
        byRegDate: "Rekisteröintipäivän järjestyksessä",
        byCategory: "Luokan järjestyksessä",
        byAccountant: "kirjanpitäjän nimen järjestyksessä",
        byBank: "pankin nimen järjestyksessä",
        byName: "nimen järjestyksessä",
        bySubject: "subjektin nimen järjestyksessä",
        byClient: "asiakkaan nimen järjestyksessä",
        byStatus: "työtilan järjestyksessä",
        byAddress: "osoitteen järjestyksessä",
        byCost: "maksusumman järjestyksessä ",
        byCar: "autolajin järjestyksessä",
        byFullName: "koko nimen järjestyksessä",
        byWorkerPosition: "ammattitason järjestyksessä",
        byContactPosition: "työntehtävän nimikkeen järjestyksessä",
        byMileage: "Kilometrimäärän järjestyksessä",
        byNumber: "numeron järjestyksessä",
        byBranch: "työalan järjestyksessä",
        byCompany: "yrityksen nimen järjestyksessä",
        byType: "dokumenttityypin järjestyksessä",

        byPhone: "puhelinnumeron järjestyksessä",
        byEmail: "sähköpostiosoitteen järjestyksessä",
        byRegNumber: "rekisterinumeron järjestyksessä",
    },
    menu: {
        'holidays': 'Holidays',

        charts: 'kaavio',

        main: "Etusivu",
        news: "Uutiset",
        "news-item": "Uutinen",
        "news-add": "Lisätä uutinen",
        "news-edit": "Korjata uutinen",
        workers: "Työntekijät",
        "workers-item": " Työntekijä",
        "worker-timings": "Työntekijän Tuntiraportti",
        clients: "Muistikirja",
        "clients-item": "Asiakkaan kohta",
        partners: "Kumppanit",
        contacts: "Firman ytheystiedot",
        objects: "Työmaat",
        "objects-item": "Objektin kohta",
        "object-timings": "Objektin tuntiraportit",
        calendar: "Kalenteri",
        faq: "Tuki",
        timings: "Tuntiraportti",
        accounting: "Kirjanpito",
        settings: "Asetukset",
        "settings-item": "Asetuksien kohta",
        waybills: "Rahtikirja",
        addWaybill: "Lisätä rahtikirjaa",
        BookkeepingView: "Kirjanpidon näkö",
        documents: "Dokumentit",
        'documents-absence': "Dokumentit puutuvat",
        'documents-timings': "Raportointi",
        addBookkeeping: "Lisätä dokumenttia",
        garage: "Autotalli",
        "garage-item": "Autotallin kohta",
        profile: "Profiili",
        'clients-profile': "Asiakkaan profiili",
        groups: "Ryhmät",
        AuthLayout: "Tunnistus",
        ResetPassword: "Nollata salasanaa",
        SignUpLayout: "Rekisteröinti",
        SignUpTenantLayout: "Rekisteröinti",
        404: "Ei löydetty",
        useful: "Hyödyksi",
        absence: "Puute",
        TechnicalWorks: "Teknilliset Työt",
        todo: "Tehtävä lista",
        "todo-object": "Tehtävä lista",
        catalog: "Tuoteluettelo",
        addOrder: "Lisä tilaus",
        editOrder: "Muoka tilaus",
        businessCards: "Henkilökortit",
        tenants: "Alustan vuokralaiset",
        tariffPlans: "Pakettisuunnitelmat",
        organizations: "Yritykset",
        company: "Yrityksen tiedot",
        SuccessLayout: "Maksu onnistui",
        ErrorLayout: "Maksuvirhe",
        safe: "Tallelokero",
        notifications: "Hälytykset",
        SelectCompany: "Valitse yritys",
        timingChangesList: "Tuntiraportin muutokset",
        'reports': "Kirjanpidon raportteja",
        'extracts': 'Pankkitiliotteet',
        'contracts': 'Sopimukset',
        'property': 'Maaomaisuus',
        'purchases': 'Kustannukset',
        'sales': 'Tulot',
        'offers': 'Hintatarjoukset',
        "languages": "Languages",
    },
    goto: "Mennä otsikolle",
    gotoProfile: "Mennä profiiliin",
    archive: "Arkisto",
    outArchive: "Poistua arkistosta",
    toArchive: "Arkistoida",
    deleteArchive: "Poistaa arkistosta",
    printDoc: "Tulostaa lomaketta",
    loadDoc: "Ladata dokumenttia",
    main: {
        see_all: "Katsoa kaikkia",
        profile: {
            label: "Profiili"
        },
        news: {
            label: "Uutiset"
        },
        calendar: {
            label: "Lähestyneet tapahtumat"
        }
    },
    widgets: {
        h1Label: "Pienoisohjelmat",
        new: "Uusi pienoisohjelma",
        selectWidget: "Valitkaa pienoisohjelmaa",
        note: {
            label: "Vihko",
            lastSave: "Viimeinen tallentaminen",
        },
    },
    workers: {
        skills: {
            outdoor_painting: "Ulkomaalaus",
            indoor_painting: "Sisämaalaus",
            manual_plastering: "Käsimaalaus",
            hardware_plastering: "Konemaalaus",
            facade_plasteir_chain: "Ulkorappaaminen teräsverkolla",
            facade_plasteir_plasterboard: " Julkisivu rappaaminen teräsverkolla",
            alignment: "Tasaus",
            carpentry_simple: "Kirvesmiehen työt",
            carpentry_formwork: "Puusepän työt",
            suspended_ceilings_giprok: "Alakatot(giprok)",
            suspended_ceilings_panels: " Alakatot(paneelit)",
            partition_walls: "Jakoseinät",
            tile_waterproofing: "Kaakeli ja kosteussuojaus",
            floor_parquet: "Parketin asentaminen",
            floor_laminate: "Laminaatin asentaminen",
            masonry: "Muurarin työt",
            concrete_works: "Betoonityöt",
            concrete_installation: "Betooniosien asettaminen",
            reinforcement: "Raudoitus",
            roof_tiles: "Katon asentaminen (kattotiili)",
            roof_metal: "Katon asettaminen (metalli)",
            bitumen_roof: "Bitumityöt (katto)",
            bitumen_plinth: "Bitumityöt(jalusta)",
            welding: "Hitsaus",
            diamond_cutting_drilling: "Timanttisahaus ja poraustyöt",
            control_loader: "Kuormaimen johto",
            control_lift: "Nosturimen johto",
            control_tractor: "Traktorin johto",
            control_transport: "Ammattilaitteen käyttö",
            loader: "Kuormain",
            lift: "Nosturi",
            linoleum: "Linoleumi",
            epoxy_coating: "Epoksikate peittaus",
            electrics: "Sähköistys",
            plumbing: "Putkityöt",
            sandblasting: "Hiekkapuhallus",
            dismantling: "Purkaaminen/hajottaminen",
            asbestos: "Asbestityöt",
            cleaning: "Siivous",
        }
    },
    timings: {
        add: "Lisätä raporttia",
        tabs: {
            piecework: "Urakkatyön palkka",
            hourly: "Tuntipalkka",
            fixed: "Kokopäivätyön Palkka",
        }
    },
    statistic: "Statistiikka",
    accounting: {
        card: {
            scan: "Scannaus",
            worker: "Työntekijä",
            category: "Kategoria",
            period: "Ajanjakso",
            bank: "Pankkinimi",
            date: "Päivämäärä",
            datecontracts: "Päätöspäivämäärä",
            datedocuments: " Allekirjoituspäivämäärä",
            dateproperty: " Allekirjoituspäivämäärä",
            datepurchases: "Maksupäivämäärä",
            dategarage: "Remonttipäivämäärä",
            dateCreate: "Toimituspäivämäärä",
            dateReceipt: "Kuittauspäivämäärä",
            dateRemind: "Muistutuspäivämäärä",
            dateDelivery: "Toimituspäivämäärä",
            dueDate: "Voimassa asti",
            subject: "Subjekti",
            concluded: "Tehty kanssa",
            name: "Nimi",
            contractName: "Sopimuksen nimi",
            documentName: "Dokumentin nimi",
            author: "Kirjanpitäjä",
            status: "Tila",
            percentDelay: "Viivästyskorko",
            statusPayed: "Maksettu",
            statusCreated: "Toimitettu",
            statusExpired: "Viivästynyt",
            cost: "Maksusumma",
            address: "Osoite",
            sum: "Summa",
            place: "Paikka",
            tax: "Arvonlisävero alv",
            paymentMethod: "Maksutapa",
            bankCard: "Pankkikortti",
            bankTransfer: "Maksu siirto",
            cash: "Käteisellä",
            client: "Tilaaja",
            object: "Objekti",
            numberLink: "Linkkinumero",
            id: "Numero",
            number: "Tilaus numero",
            description: "Laskutuksen huomautus",
            comment: "Muistiinpanot",
            term: "Ajanjakso",
            addService: "Lisätä palvelu",
            price: "Hinta",
            discount: "Alennus(%)",
            type: "Tuote/Palvelu",
            typeMaterial: "Tuote",
            typeService: "Palvelu",
            date_start: "Matkanalkuun päivämäärä",
            date_end: "Matkan loppuun päivämäärä",
            time_start: "Työn alkaamisaika",
            time_end: "Työn päättymisaika",
            way_time: "Matkan kesto",
            mileage: "Kilometrimäärä",
            mileageStart: "Km alussa",
            mileageEnd: "Km lopulla",
            mileageTotal: "Km yhteensä",
            departure: "Lähtöpaikka",
            destination: "Tulopaikka",
            auto: "Rekisteriote",
            goal: "Matkan tavoite",
            material: "Materiaalit, kaikki kiinnikkeet ja käyttömateriaalit",
            delivery: "Materiaalin toimitus varastosta tai kaupasta доставка материала со склада или магазина työmaalle",
            tool: "työkalu",
            lifts: "nosturit",
            scaffolding: "Metsän",
            montage_scaffolding: "Metsän asennus ja leikkaus",
            garbage: "Roskan vienti ja poisto",
            garbage_containers: "Jätelavat",
            security: "Työmaan vartiointi",
            social_room: "Sosiaalitilat, joissa on vesi, mahdollisuus vaihtaa vaatteet ja syödä ja vessa",
            unloading: "Materiaalien kuorman purkaminen",
            spreading: "Materiaalien vienti työmaan alueella",
            cleaning: "Siivous työmaalla",
            numberBill: "Laskun numero",
            bundle: "Kuittien sarja",
            bundleSingle: "Yksi kuitti",
            bundleMultiple: "2 ja enemmän",
            car: "Auto"
        },
        statistic: {
            count: "Yhteensä",
            categories: "Kategoriat",
            byCategory: "Kategorien järjestyksessä",
            perMonth: "Laskuja yhteensä",
            clients: "Asiakkaiden määrä",
            sum: "Bruttosumma",
            sumTax: "Nettosumma"
        },
        reports: {
            label: "Kirjanpidon raportteja",
            new: "Uusi kirjanpidon raportti",
            scan: "Raportin skannaus",
            info: "Tieto raportista",
        },
        extracts: {
            label: "Pankkitiliotteet",
            new: "Uusi tiliote",
            scan: "Tiliotteen skannaus",
            info: "Tiliotteesta",
        },
        contracts: {
            label: "Sopimukset",
            new: "Uusi sopimus",
            scan: "Sopimuksen skannaus",
            info: "Sopimuksen sisältö",
        },
        documents: {
            label: "Dokumentit",
            new: "Uusi dokumentti",
            scan: "Dokumentin skannaus",
            info: "Dokumenttista",
        },
        property: {
            label: "Maaomaisuus",
            new: "Uusi dokumentti maaomaisuudesta",
            scan: "Dokumentin scannaus",
            info: "Dokumenttista",
        },
        purchases: {
            label: "Kustannukset",
            new: "Uusi lasku",
            scan: "Laskun skannaus",
            info: "Laskutuksen sisältö",
        },
        sales: {
            label: "Tulot",
            new: "Uusi lasku",
            scan: "Lasku",
            number: "Laskun numero"
        },
        offers: {
            label: "Hintatarjoukset",
            new: "Uusi hintatarjous",
            scan: "Hintatarjouksen skannaus",
            number: "Hintatarjouksen numero"
        },
        waybills: {
            label: "Rahtikirjat",
            new: "Uusi rahtikirja",
            scan: "Dokumentin skannaus",
            info: "Rahtikirjasta tieto",
        },
        garage: {
            label: "Autoremontti",
            new: "Uusi dokumentti",
            scan: "Dokumentin skannaus",
            info: "Remontista",
        },
        details: "Yksityiskohdat",
        serviceList: "Palvelulista",
        newService: "Uusi palvelu",
        totalWithoutTax: "Yhteensä ilman alv.",
        total: "Yhteensä",
        fromClient: "Tilaajalta"
    },
    account: "Oma profiili",
    auth: "Tunnistus",
    registration: "Rekisteröinti",
    password: "Salasana",
    forget: "Unohtuuko salasana?",
    enter: "Kirjautua sisään",
    create: "Luoda profiilin",
    stayIn: "Pysyä systeemissä",
    logout: "Poistua profiilista",
    other: "Muut",
    passport: "Passin numero",
    residence: "Oleskelulupa",
    signup: {
        cancel: "Peruuta rekisteröintiä",
        hello: "Hei! Tämän verkkosivun työskentelyä varten tarvitaan henkilökohtaiset tiedot: ",
        name: "Nimi",
        lastname: "Sukunimi",
        wantTitle: "Haluatko työskennellä meillä?",
        wantSubtitle: "Täytäthän kyselylomaketta. Täyttäminen vaatii noin 15 minuuttia. Henkilökohtaiset tiedot käytetään vain työllistymisprosessiin ja työpaikalla käyttöön, ulkopuolisille ne eivät ole saatavilla",
        birthdate: "Syntymäpäivämäärä",
        bankAccount: "Pankkitilinumero",
        whereTitle: "Missä asut? Osoite?",
        whereSubtitle: "Osoitetta tarvitaan rekisteröintiä ja yrityskirjojen lähettämistä varten",
        addressFin: "Osoite Suomessa",
        addressFromFin: "Kun olet pysyvä asukas Suomessa, on riittävästi kirjoittaa suomen osoitetta",
        addressOwn: "Osoite omassa maassa",
        additionalTitle: "Vähän lisätietoja",
        additionalSubtitle: "Tätä tietoa myös tarvitaan ja tässä on selitys miksi",
        skillsTitle: "Arvioi omia kykyjä",
        skillsSubtitle: " Näin saat vain niitä projekteja, joiden kanssa pärjäät parhaiten",
        mainSpec: "Pääammattisi",
        selectSpec: "Valitse ammattiasi listasta",
        almostTitle: "Melkein kaikki...",
        almostSubtitle: "Lataa dokumentit listasta työpaikan mahdollisuuden saamiseen",
        photo: "Valokuva sinusta",
        photoSubtitle: " Varmista että kasvosi näkyy hyvin ja katsot suoraan kameraan. Mieluummin tulisi passityyppinen kuva",
        residenceSubtitle: "Ulkomaalaisille tämä dokumentti on pakollinen",
        cardsTitle: "Enää kortteja jäljellä",
        cardsSubtitle: "Valitse kaikki kortit, mitä sinulla on. Verokortin oleminen on pakollista! Jos listasta puuttuu jotakin kortteista niin voit ladata niitä myöhemmin oman profiiliin korjaamis-napista",
        congratTitle: "Onnea!",
        congratSubtitle: "Profiilisi on onnistuneesti luotu. On mahdollista lisätä puutuvat tiedot ja korjata jo olemassa olevat profiiliotsikosta ”korjata”. Voit aloitta työsi pfofiilissasi!",
        congratRentSubtitle: "Hakemuksesi on vastaanotettu. Otamme sinuun yhteyttä 7 arkipäivän sisällä keskustellaksemme alustavuokrauksen yksityiskohdista. Aloitettu myös 14 päivän kokeilujakson.",
        wantRentTitle: "Haluatko vuokrata alustan?",
        wantRentSubtitle: "Voit tehdä tämän täyttämällä yritystäsi koskevan kyselylomakkeen, jotta alustasta tulee toiminnallesi sopivin. Kyselylomakkeen täyttäminen vie noin 5 minuuttia.",
        contactInfoTitle: "Yhteisteidot",
        contactInfoSubtitle: "Kuinka voimme ottaa sinuun yhteyttä?",
        detailsSubtitle: "Luodaksesi laskun maksua varten",
    },

//для старой версии
    Index: {
        h1Label: "Pääsivu",
        hello: "Tervetuloa, ",
        todayLabel: "Tänään suunnitellussa",
        statistics: {
            news: {
                label: "Uutiset: ",
                text: "yhteensä uutisia"
            },
            workers: {
                label: "Työntekijät: ",
                all: "yhteensä työntekijöitä",
                new: "Tänään uusien määrä",
                text: "Työskentelee: ",
            },
            clients: {
                label: "Asiakkaat: ",
                all: "yhteensä asiakkaita",
                new: "Uusia tänään yhteensä",
            },
            objects: {
                label: "Työmaat: ",
                all: "yhteensä",
                text: "Aktiivisia",
            },
            calendar: {
                label: "Kalenteri: ",
                all: "tapahtumat yhteensä",
                week: "Tällä viikolla yhteensä",
                today: "Tänään yhteensä",
            },
        },
    },
    settings: {
        'holidays': 'Holidays',
        'workTypes': 'Työn tyypit',
        'language-settings': 'Languages',

        selectThemeLabel: "Teeman valinta",
        selectLangLabel: "Rajapinnan kieli",
        languages: {
            rus: "Venäjä",
            eng: "Englanti",
            fin: "Suomi",
            est: "Viro",
            ukr: "Ukraina",
            swe: "Ruotsi",
        },
        groups: "Käyttäjien ryhmien hallinta",
        workerPosition: "Työntekijoiden erikoisala",
        contactPosition: "Kontaktihenkilöiden ammatit",
        chequeCategories: "Kuittien kategoriat",
        reportsCategories: "Kirjanpidon raporttien kategoriat",
        goals: "Matkan tavoitteet",
        banks: "Pankit",
        terms: "Ajanjaksot",
        tax: "Verot",
        cards: "Kortit",
        read: "Lukeminen",
        edit: "Korjaaminen",
        absenceReasons: "Puutamissyy",
        skills: "Kykyjä",
        companyData: "Yrityksen tiedot",
        tripTime: "Matka-aika raportointia varten",
    },

    invalid_credentials: "Väärä sähköposti tai salasana. Tarkista ovatko tiedot oikein",
    recoveryPassword: "Salasanan uusiminen",
    repeatPassword: "Salasana uudestaan",
    emailNotification: "Salasanan uusimista varten on lähetetty linkki sähköpostitse",
    recoveryButton: "Salasanan palautuminen",
    samePasswordRule: "Salasanat eivät täsmää",
    min8Rule: "Symbolien minimimäärä on 8",
    notFound: "Sivua ei löydy",
    notFoundSubtitle: "Näyttää siltä että linkkiä ei ole olemassa tai osoite on väärä",
    goMain: "Mennä pääsivulle",
    editingComment: "Kommentin korjaus",
    pause: "Tauko",
    minutes: "min",
    hour: "h",
    hours: "Tuntimäärä",
    sortDescending: "lajittele alenevasti",
    sortAscending: "lajittele nousevasti",
    perPage: "Sivulla",
    details: "Tiedustelutiedot",
    addDetails: "Lisätä Tiedustelutiedot",
    editDetails: "Korjata Tiedustelutiedot",
    selectType: "Valitse tyyppi",
    "e-account": "Sähkölasku",
    detailAddress: "Sähkölaskua varten osoite",
    operator: "Operaattori",
    operator_id: "Operaattorin tunnistus",
    invoice_address: "Laskulle Email",
    client_name: "Asiakkaan nimi",
    bank: "Pankki",
    bic: "BIC-koodi",
    iban: "IBAN-tilinumero",
    addLink: "Lisätä linkin",
    editLink: "Korjata linkkiä",
    addCategory: "Lisätä kategoriaa",
    link: "Linkki",
    newComments: "Uusia kommentteja",
    notFoundAnswer: "Eikö löydy vastausta kysymykseesi?",
    text: "Teksti",
    reason: "Puutumisen syy",
    showQua: "Antaa tietoja lomakkeeseen",

    technical: "Verkkosivulla on tällä hetkellä teknisiä ongelmia. Ole hyvä, käy tarkistamassa myöhemmin uudelleen",
    technicalTime: "Korjauksen keston arvio on klo 13–23",
    error500: "Palvelimen sisäinen virhe",
    selectShownHeaders: "Kuvaavien alueiden valinta",
    preview: "Esikatselu",
    payment: "Maksu",
    sendToEmail: "Lähetä sähköpostilla",
    send: "Lähetä sähköpostilla",
    simpleReg: "Lyhyt rekisteröinti",
    history: "Muutosten historia",
    author: "Kirjailija",
    beforeChanges: "Ennen muutoksia",
    afterChanges: "Muutosten jälkeen",
    answer: "Vastaus kommenttiin",
    markRead: "Merkitse luetuksi",
    read_timings: "Anna pääsy raportteihin",
    productCode: "Tuotteen koodi",
    eanCode: "EAN",
    shops: "Kaupat",
    shop: "Kaupa",
    addShop: "Lisää kauppa",
    sellers: "Myyjät",
    seller: "Myyjä",
    addSeller: "Lisää myyjä",
    addProduct: "Lisää tuote",
    connection: "Yhteistiedot",
    rentPlatform: "Vuokraa alusta",
    contactPerson: "Yhteishenkilö",
    contactPersonSubtitle: "Tämä henkilö on järjestelmän ensimmäinen käyttäjä ja ylläpitäjä",
    subdomain: "Aliverkkotunnus",
    lastLogin: "Viimeinen kirjautuminen",
    products: "Kaupat",
    addBusinessCard: "Lisää henkilökortti",
    frontPhoto: "Etupuoli",
    backPhoto: "Takapuoli",
    todoComment: "Kommentti lisätään objektiin",
    addTask: "Lisää tehtävä",
    workerLimit: "Työntekijöiden määrä",
    functions: "Toiminnot",
    paid_until: "Maksettu asti",
    domain: "Verkkotunnus",
    onTrial: "Koeaika",
    choose: "Valitse",
    chooseTariff: "Valitse suunnitelma",
    chosen: "Valittu",
    rentInfo: "Vuokratiedot",
    createdDateTenant: "Rekisteröintipäivä",
    tariffPlan: "Paketti",
    changeTariff: "Päivitä paketti",
    pay_platform: "Jos haluat jatkaa alustan käyttöä, maksa lasku",
    archiveable: "Arkistoi 7 päivän kuluttua",
    success: "Maksu onnistui",
    error: "Maksuvirhe",
    contactAdmin: "Ota yhteyttä ylläpitäjään",
    stripe: "Tuotekoodi Stripe",
    pay: "Maksaa",
    uploadedFiles: "ladatud failit",
    safePassword: "Tallelokeron salasana",
    updatePassword: "Päivitä salasana",
    invalidPassword: "Väärä salasana",
    safeAlert: "Emme suosittele salasanojen ja muiden tärkeiden tietojen tallentamista lokeron..\n Work24 ylläpitäjät ei ole vastuussa lokeron tietojen turvallisuudesta.",
    dateTimings: "Raporttien päivämäärät",
    withArch: "Harkitse arkistointi",
    copy: "Kopioi",
    timingChanges: "Tuntiraportin muutokset",
    checkIn: "Check in",
    checkOut: "Check out",
    workerOnObject: "Työmaalla alkaen ",
    showGeo: "Näytä sijainti",
    endWithoutReport: "Lopeta ilman raporttia",
    translate: "Käänä",
    showOriginal: "Näytä alkuperäinen ",
    repeat: "Toista",
    once: "Kerran",
    weekly: "Viikoittain",
    monthly: "Kuukausittain",
    yearly: "Vuotuinen",
    until: "Kunnes",
    showHistory: "Näytä historia",
    contactsVisible: "Tee yhteystiedot näkyviin",
    geoError: "Sijainnin virhe",
    workerLimitError: "Järjestelmän sallittu työntekijämäärä on ylitetty",
    changeDate: "Siira toiselle päivälle",
    downloadAllFiles: "Lataa kaikki kuvat",
    addSignature: "Tarkistus allekirjoitus",
    signature: "Allekirjoitus",
    permissionError: "Pääsy estetty",
    methodNotAllowedError: "Menetelmä ei ole sallittu",
    unexpectedError: "Odottamaton virhe",
    userExists: "Käyttäjä on jo olemassa",
    tripTime: "Matka-aika",

    "dgantt": {
        "title": "Kaavio",
        "tasks": "Tehtävät",
        'workType': 'työn tyyppi',

    },
    "months": {
        "Jan": "Tammikuu",
        "Feb": "Helmikuu",
        "Mar": "Maaliskuu",
        "Apr": "Huhtikuu",
        "May": "Toukokuu",
        "Jun": "Kesäkuu",
        "Jul": "Heinäkuu",
        "Aug": "Elokuu",
        "Sep": "Syyskuu",
        "Oct": "Lokakuu",
        "Nov": "Marraskuu",
        "Dec": "Joulukuu"
    },
    "days": {
        "Mon": "Maa",
        "Tue": "Tii",
        "Wed": "Kes",
        "Thu": "Tor",
        "Fri": "Per",
        "Sat": "Lau",
        "Sun": "Sun"
    },

    "days_genitive": 'vrk',

    "filter": "Suodatin",
    expiredDocuments: "Myöhästyneet asiakirjat",
    upcomingAbsence: "Tulevat lomat",
    'selectedSection': 'Valittu osio',

    'holiday-work': 'travail le week-end',
    organizationCar: "Järjestöauto",
    personal: "Henkilökohtainen",
    fromOrganization:"Organisaatiot",
    maybe: "Ehkä tarkoitit",
    partners: "Kumppanit",
    fromNotes: "Muistikirjasta",
    invitations: "Kutsut",
    from: "Lähettäjä",
    accept: "Hyväksy",
    reject: "Hylkää",
    find: "Etsi",
    contractor: "Contractor",
};
//# sourceMappingURL=ru.js.map
